var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99961 6.26676V10.0001M9.99961 13.7334H10.0089M18.3996 10.0001C18.3996 14.6393 14.6388 18.4001 9.99961 18.4001C5.36042 18.4001 1.59961 14.6393 1.59961 10.0001C1.59961 5.36091 5.36042 1.6001 9.99961 1.6001C14.6388 1.6001 18.3996 5.36091 18.3996 10.0001Z",
    stroke: "#B45309",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectIcon);
export default __webpack_public_path__ + "static/media/reject-Icon.0dc1ab136b5712a842977a9524ed8f42.svg";
export { ForwardRef as ReactComponent };